<template>
  <v-app>
    <v-app-bar app
    dark
    color="deep-purple">
      <v-container>
        <v-layout row justify-center>
          <v-toolbar-title>Make My Bio</v-toolbar-title>
        </v-layout>
      </v-container>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    //
  })
};
</script>

<style>
.fill-height {
  height: 100%;
}

.pd-16 {
  padding: 16px;
}

.text-center {
  text-align: center;
}

.d-flex {
  display: flex;
}

.justify-center {
  justify-content: center;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.align-items-center {
  align-items: center;
}

.align-items-start {
  align-items: flex-start;
}

.align-items-end {
  align-items: flex-end;
}

.flex-grow-1 {
  flex-grow: 1;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.d-grid {
  display: grid;
}

.detail-section {
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 14px;
  grid-auto-flow: row;
  padding: 4px;
}

.full-min-height {
  min-height: 100%;
}

.profile-view-pic {
  width: 90px;
  height: 90px;
  border-radius: 50%;
}

.profile-edit-pic {
  width: 64px;
  height: 64px;
  border-radius: 50%;
}

.title-style {
  background: rgba(211, 211, 211, 0.4);
  padding-left: 4px;
}

.pl-0 {
  padding-left: 0;
}

.pr-0 {
  padding-right: 0;
}

.info-container {
  padding: 8px;
}

.author-container {
  padding: 10px;
}

@media print {
  html {
    zoom: 100%;
  }
  header.v-sheet {
    display: none; 
  }  

  main.v-content {
    padding: 0;
  }

  head title {
    display: none;
  }

  main.v-content {
    padding: 0;
  }

  #bioDetailContainer {
    padding: 0; 
  }

  .full-min-height.v-card {
    box-shadow: unset !important;
    border: none !important;
  }

  .profile-view-pic {
    width: 100px;
    height: 100px; 
  }

  .detail-section {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 14px;
    grid-auto-flow: row;
  }
}

@page {
  margin : 0;
  @top-center {
    content: "Moby-Dick";
  }

  @bottom-left {
      content: "page " counter(page);
  }
}

</style>
